import {eINVALID} from "./invalidvalue";
import {VariableValue} from "./VariableValue";
import {Injectable, OnInit} from "@angular/core";
import {interval, Observable, Subscription} from "rxjs";
import {VariableDataService} from "./VariableDataService";
import {UiValue} from "../cards/CardStruct";

export enum eOPTION_FLAGS {
  eOPTION_NONE,
  eOPTION_SINGLE_ITEMS,
  eOPTION_MULTI_ITEMS
}


@Injectable({
  providedIn: 'root'
})


export class VariableDataBase  {
  private static values: VariableValue[] = Array();   // Holds all values on the page (object will find the values in here)
  private timer: any;
  private optionFlags: number = 0;

  constructor(private variableDataService: VariableDataService) {
    this.RetrieveOptionsFlags();
  }

  RetrieveOptionsFlags(): void {
    this.variableDataService.Get(0).subscribe(
      {
        next: uiValue => {
          this.optionFlags =  (uiValue) ? (uiValue.flags) ? uiValue.flags :  eOPTION_FLAGS.eOPTION_SINGLE_ITEMS  : eOPTION_FLAGS.eOPTION_SINGLE_ITEMS;
          console.log('UI Data Flags are', this.optionFlags );
          this.LoadAndStart(2000);
        }
      });
  }

  TestOptionsFlags( flags:eOPTION_FLAGS): boolean {
    return (this.optionFlags & flags) ? true : false;
  }

  Empty():void{
    while(VariableDataBase.values.length)
      VariableDataBase.values.pop();
  }

  private static FindOrCreateValueByReference(reference: number): &VariableValue {
    for(let item of VariableDataBase.values)
    {
       if(item.ref == reference) {
         return item;
       }
    }
    var variableValue: VariableValue = new VariableValue();
    variableValue.ref = reference;
    VariableDataBase.values.push(variableValue);
    return variableValue;
  }

  AddValueByReference(reference: number): &VariableValue {
    var variableValue: &VariableValue = VariableDataBase.FindOrCreateValueByReference(reference)
    variableValue.val   = eINVALID.eINVALID;
    variableValue.ahm   = eINVALID.eINVALID;
    variableValue.value = "eINVALID.eINVALID";
    return variableValue;
  }

  private LoadAndStart(timeout: number):void {
    this.timer = setInterval(() => {
      if(this.TestOptionsFlags(eOPTION_FLAGS.eOPTION_MULTI_ITEMS))
          this.GetMultipleItemData();
      else
        this.GetMultipleItemsBySingle();
    }, timeout);
  }

  GetMultipleItemData() {
    console.log("Update All members using MULTI", VariableDataBase.values.length);
    clearInterval(this.timer);
    this.variableDataService.GetDataByPost(VariableDataBase.values).subscribe({
        next: valuesList => {
          if (!valuesList)
            return;
          for (let value of valuesList.values) {
            var variable = VariableDataBase.FindOrCreateValueByReference(value.ref);
            variable.val = value.val;
          }
          this.LoadAndStart(5000);
        }
      });
  }


  private GetMultipleItemsBySingle(): void {
    clearInterval(this.timer);
    console.log("Update All members using single", VariableDataBase.values.length);
    for(let valueItem of VariableDataBase.values)
      this.GetSingleItemData(valueItem);
    this.LoadAndStart(30000);
  }

  GetSingleItemData(variable: &VariableValue) {
    if (variable.ref != -1) {
      this.variableDataService.Get(variable.ref).subscribe({
        next: uiValue => {
          if (uiValue != null) {
            variable.val = uiValue.value;
          } else {
            console.log("Single value: NULL: ", variable.ref);
          }
        }
      });
    }
  }
}
